import { createStore } from "@stencil/store";

interface GroupMember {
  userId: string;
  userName: string;
  userProfileImageUrl: string;
  isAdmin: boolean;
}

interface GroupMembersState {
  members: GroupMember[];
  currentConversationId: string | null;
}

const { state } = createStore<GroupMembersState>({
  members: [],
  currentConversationId: null
});

export const groupMembersStore = {
  state,

  initializeMembers(members: GroupMember[], conversationId: string) {
    state.members = members;
    state.currentConversationId = conversationId;
  },

  updateAdminStatus(userId: string, isAdmin: boolean) {
    state.members = state.members.map(member => {
      return member.userId === userId ? { ...member, isAdmin } : member;
    });
  },

  getMembers() {
    return state.members;
  },

  getCurrentConversationId() {
    return state.currentConversationId;
  }
};